// extracted by mini-css-extract-plugin
export default {"container":"_r-z","ratingLayout":"as-z","ratingLabel":"bs-z"};